module.exports = __webpack_public_path__ + "img/add-property-white.b0a87813.png";